var PostListByCategory = /** @class */ (function () {
    function PostListByCategory(element) {
        this.currentPage = 1;
        this.postsPerPage = 6;
        this.totalPosts = 0;
        this.body = document.querySelector('body');
        this.pageOverlay = document.querySelector('.page-overlay');
        this.pageLoader = document.querySelector('.page-loader');
        this.postListByCategoryBlock = element;
        this.postList = this.postListByCategoryBlock.querySelector('.post-list-by-category-items.alt');
        this.postItems = this.postList.querySelectorAll('.post-list-by-category-item');
        this.loadMoreButton = this.postListByCategoryBlock.querySelector('.load-more');
        this.totalPosts = this.postItems.length;
        if (this.loadMoreButton) {
            this.addEventListeners();
        }
    }
    PostListByCategory.prototype.addEventListeners = function () {
        this.loadMoreButton.addEventListener('click', this.loadMorePosts.bind(this));
    };
    PostListByCategory.prototype.loadMorePosts = function (event) {
        event.preventDefault();
        this.currentPage++;
        var offset = (this.currentPage - 1) * this.postsPerPage;
        var hiddenPosts = Array.from(this.postItems).filter(function (postItem) { return postItem.classList.contains('hidden'); });
        hiddenPosts.slice(0, this.postsPerPage).forEach(function (postItem) {
            postItem.classList.remove('hidden');
        });
        if (this.currentPage * this.postsPerPage >= this.totalPosts) {
            this.loadMoreButton.style.display = 'none';
        }
    };
    return PostListByCategory;
}());
var postListByCategoryBlocks = document.querySelectorAll('[data-post-list-by-category-block]');
postListByCategoryBlocks.forEach(function (postListByCategoryBlock) { return new PostListByCategory(postListByCategoryBlock); });
